if (!customElements.get('collapsible-tabs')) {
  customElements.define(
    'collapsible-tabs',
    class CollapsibleTabs extends HTMLElement {
      constructor() {
        super();
        this._onHashChange = this._onHashChange.bind(this);
      }

      connectedCallback() {
        this.detailsElements = this.querySelectorAll('.accordion-details');
        this.colorScheme = this.dataset.colorScheme;

        this.detailsElements.length > 0 &&
          this.detailsElements.forEach((details) => {
            details.open ? this.handleOpen(details) : this.handleClose(details);
            details.addEventListener('toggle', this.onToggle.bind(this));
          });

        window.addEventListener('hashchange', this._onHashChange);
        this._openFromHash();

        this.addEventListener('click', (e) => {
          const anchor = e.target.closest('a[href*="#"]');
          if (!anchor) return;
          const hash = anchor.hash;
          if (!hash) return;
          const target = document.querySelector(hash);
          if (target && target.classList.contains('accordion-item')) {
            e.preventDefault();
            this._openAndScrollTo(target);
            history.pushState(null, '', hash);
          }
        });
      }

      disconnectedCallback() {
        window.removeEventListener('hashchange', this._onHashChange);
      }

      _onHashChange() {
        this._openFromHash();
      }

      _openFromHash() {
        const hash = window.location.hash;
        if (!hash) return;
        const target = document.querySelector(hash);
        if (target && target.classList.contains('accordion-item')) {
          this._openAndScrollTo(target);
        }
      }

      _openAndScrollTo(accordionItem) {
        const details = accordionItem.querySelector('.accordion-details');
        if (details && !details.open) {
          details.open = true;
          details.setAttribute('aria-expanded', 'true');
        }
        accordionItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      onToggle(event) {
        const activeDetails = event.target;
        if (activeDetails.open) {
          this.handleOpen(activeDetails);
        } else {
          this.handleClose(activeDetails);
        }
      }

      handleOpen(details) {
        const parent = details.closest('.accordion-item');
        parent.classList.contains('accordion-card') && parent.classList.add(this.colorScheme);
      }

      handleClose(details) {
        const parent = details.closest('.accordion-item');
        parent.classList.contains('accordion-card') && parent.classList.remove(this.colorScheme);
      }
    }
  );
}

document.addEventListener('click', (e) => {
  const anchor = e.target.closest('a[href*="#"]');
  if (!anchor) return;
  const hash = anchor.hash;
  if (!hash) return;
  try {
    const target = document.querySelector(hash);
    if (target && target.classList.contains('accordion-item')) {
      e.preventDefault();
      const details = target.querySelector('.accordion-details');
      if (details && !details.open) {
        details.open = true;
        details.setAttribute('aria-expanded', 'true');
      }
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      history.pushState(null, '', hash);
    }
  } catch (_) {}
});
